import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary, ToastProvider } from '@adop/ui';
import { AuthProvider } from './lib/auth';
import { WorkspaceProvider } from './lib/workspace';
import { RequireAuth } from './components/RequireAuth';
import { DashboardLayout } from './components/DashboardLayout';
import { MarketplacePage } from './pages/MarketplacePage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { RegisterPage } from './pages/RegisterPage';
import { InvitePage } from './pages/InvitePage';
import { LegalPage } from './pages/LegalPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { HomePage } from './pages/dashboard/HomePage';
import { OrdersPage } from './pages/dashboard/OrdersPage';
import { TableBoardPage } from './pages/dashboard/TableBoardPage';
import { TablesPage } from './pages/dashboard/TablesPage';
import { VisibilityPage } from './pages/dashboard/VisibilityPage';
import { ReservationsPage } from './pages/dashboard/ReservationsPage';
import { MenuPage } from './pages/dashboard/MenuPage';
import { HoursPage } from './pages/dashboard/HoursPage';
import { BrandingPage } from './pages/dashboard/BrandingPage';
import { PaymentsPage } from './pages/dashboard/PaymentsPage';
import { BillingPage } from './pages/dashboard/BillingPage';
import { ReservationSettingsPage } from './pages/dashboard/ReservationSettingsPage';
import { DomainPage } from './pages/dashboard/DomainPage';
import { PrintersPage } from './pages/dashboard/PrintersPage';
import { TeamPage } from './pages/dashboard/TeamPage';
import { LocationsPage } from './pages/dashboard/LocationsPage';
import { StatsPage } from './pages/dashboard/StatsPage';
import { ActivityPage } from './pages/dashboard/ActivityPage';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage';
import { AdminRestaurantsPage } from './pages/admin/AdminRestaurantsPage';
import { AdminRestaurantPage } from './pages/admin/AdminRestaurantPage';
import { AdminDataPage } from './pages/admin/AdminDataPage';
import { AdminAuditPage } from './pages/admin/AdminAuditPage';
import { AdminAdminsPage } from './pages/admin/AdminAdminsPage';

export function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <WorkspaceProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<MarketplacePage />} />
                <Route path="/auth/callback" element={<AuthCallbackPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/invite/:token" element={<InvitePage />} />
                <Route path="/invite" element={<InvitePage />} />
                <Route path="/pricing" element={<LegalPage kind="pricing" />} />
                <Route path="/terms" element={<LegalPage kind="terms" />} />
                <Route path="/privacy" element={<LegalPage kind="privacy" />} />
                <Route
                  path="/dashboard"
                  element={
                    <RequireAuth>
                      <DashboardLayout />
                    </RequireAuth>
                  }
                >
                  <Route index element={<HomePage />} />
                  <Route path="orders" element={<OrdersPage />} />
                  <Route path="table-board" element={<TableBoardPage />} />
                  <Route path="tables" element={<TablesPage />} />
                  <Route path="visibility" element={<VisibilityPage />} />
                  <Route path="reservations" element={<ReservationsPage />} />
                  <Route path="menu" element={<MenuPage />} />
                  <Route path="hours" element={<HoursPage />} />
                  <Route path="branding" element={<BrandingPage />} />
                  <Route path="payments" element={<PaymentsPage />} />
                  <Route path="billing" element={<BillingPage />} />
                  <Route path="reservation-settings" element={<ReservationSettingsPage />} />
                  <Route path="domain" element={<DomainPage />} />
                  <Route path="printers" element={<PrintersPage />} />
                  <Route path="team" element={<TeamPage />} />
                  <Route path="locations" element={<LocationsPage />} />
                  <Route path="stats" element={<StatsPage />} />
                  <Route path="activity" element={<ActivityPage />} />
                  <Route path="settings/payments" element={<Navigate to="/dashboard/payments" replace />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
                <Route
                  path="/admin"
                  element={
                    <RequireAuth>
                      <AdminLayout />
                    </RequireAuth>
                  }
                >
                  <Route index element={<AdminOverviewPage />} />
                  <Route path="restaurants" element={<AdminRestaurantsPage />} />
                  <Route path="restaurants/:id" element={<AdminRestaurantPage />} />
                  <Route path="data" element={<AdminDataPage />} />
                  <Route path="audit" element={<AdminAuditPage />} />
                  <Route path="admins" element={<AdminAdminsPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </BrowserRouter>
          </WorkspaceProvider>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}
